export default __webpack_public_path__ + "static/media/doctor.321825a0.png";